module.exports = __webpack_public_path__ + "img/border_top_bottom_corner.7cf2a726.svg";